import i18n from '@/lang';
/* unplugin-vue-components disabled */
import { Card as __unplugin_components_3 } from 'vant/es';
import 'vant/es/card/style/index';
import { List as __unplugin_components_2 } from 'vant/es';
import 'vant/es/list/style/index';
import { PullRefresh as __unplugin_components_1 } from 'vant/es';
import 'vant/es/pull-refresh/style/index';
import { Search as __unplugin_components_0 } from 'vant/es';
import 'vant/es/search/style/index';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "classificationList"
  }, [_c('div', {
    staticClass: "search"
  }, [_c(__unplugin_components_0, {
    attrs: {
      "shape": "round",
      "placeholder": i18n.tc("248")
    },
    on: {
      "search": _vm.onLoad
    },
    model: {
      value: _vm.seachForm.keyword,
      callback: function ($$v) {
        _vm.$set(_vm.seachForm, "keyword", $$v);
      },
      expression: "seachForm.keyword"
    }
  })], 1), _c('div', {
    staticClass: "content"
  }, [_c(__unplugin_components_1, {
    staticClass: "productList-item",
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: _vm.loading,
      callback: function ($$v) {
        _vm.loading = $$v;
      },
      expression: "loading"
    }
  }, [_c(__unplugin_components_2, {
    attrs: {
      "finished": _vm.upFinished,
      "immediate-check": false,
      "offset": 10,
      "finished-text": i18n.tc("275")
    },
    on: {
      "load": _vm.onLoadList
    },
    model: {
      value: _vm.isUpLoading,
      callback: function ($$v) {
        _vm.isUpLoading = $$v;
      },
      expression: "isUpLoading"
    }
  }, _vm._l(_vm.classificationData, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "commodityBox"
    }, [_c(__unplugin_components_3, {
      attrs: {
        "title": item.goods_name,
        "thumb": item.goods_image
      },
      on: {
        "click": function ($event) {
          return _vm.productDetails(item);
        }
      },
      scopedSlots: _vm._u([{
        key: "price",
        fn: function () {
          return [_c('span', {
            staticClass: "price-text"
          }, [_vm._v("￥" + _vm._s(item.price))])];
        },
        proxy: true
      }, {
        key: "footer",
        fn: function () {
          return [_c('div', {
            staticClass: "shopCarImg"
          }, [_c('img', {
            attrs: {
              "src": require("@/assets/img/MH3.9/shopCart.png"),
              "alt": ""
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.addCar(item);
              }
            }
          })])];
        },
        proxy: true
      }], null, true)
    })], 1);
  }), 0)], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };